"use strict";

var _hasher = require("./hasher");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "Hasher", {
  enumerable: !0,
  get: function get() {
    return _hasher.Hasher;
  }
});